import { useEffect, useState } from "react";

/** Tick once a second — the resolution a running-duration readout needs. */
export const ONE_SECOND_MS = 1000;

/** Tick once a minute — close enough to midnight for a day's state to turn. */
export const ONE_MINUTE_MS = 60_000;

/**
 * The current epoch-millisecond timestamp, re-rendered every `intervalMs`.
 *
 * Pass `active: false` to stop the timer; the last value read is kept, so a
 * paused clock shows the moment it stopped rather than jumping on resume.
 */
export function useNow(intervalMs: number, active = true): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!active) {
      return;
    }
    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs, active]);

  return now;
}
